import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import {
  AddIcon,
  IconFace,
  IconHome,
  IconBook,
  IconPrice,
  IconHammer,
  IconMore,
} from "../components/CustomIcons";
import { useNavigate } from "react-router-dom";
import {
  getAllLeaguesByUserId,
  getUserLeagues,
} from "../components/leagueLocker/firestoreQuery";
import { useAuth } from "../contexts/AuthContext";
import defaultBannerImage from "../assets/images/league-locker-banner.png";

const DashboardPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const handleCreateLeague = () => {
    // navigate to create league page
    navigate("/create-league");
  };
  const [leagues, setLeagues] = React.useState<any[]>([]);

  useEffect(() => {
    if (!user) {
      navigate("/home");
    } else {
      // fetch leagues for the user
      const fetchLeagues = async () => {
        const leagues = await getAllLeaguesByUserId(user.uid);
        //setLeagues(leagues);
        // You can set these leagues to state and display them as needed
        const leaguesJoined = await getUserLeagues(user.uid);
        // merge both arrays and remove duplicates
        const allLeagues = [...leagues, ...leaguesJoined];
        const uniqueLeagues = Array.from(
          new Set(allLeagues.map((l) => l.id))
        ).map((id) => {
          return allLeagues.find((l) => l.id === id);
        });
        // reoder by createdAt desc or leagueName asc
        uniqueLeagues.sort((a, b) => {
          const aDate =
            a?.createdAt instanceof Date
              ? a.createdAt
              : a?.createdAt?.toDate
              ? a.createdAt.toDate()
              : null;

          const bDate =
            b?.createdAt instanceof Date
              ? b.createdAt
              : b?.createdAt?.toDate
              ? b.createdAt.toDate()
              : null;
          if (aDate && bDate) {
            return bDate.getTime() - aDate.getTime();
          } else {
            return a?.leagueName.localeCompare(b?.leagueName);
          }
        });
        setLeagues(uniqueLeagues);
      };
      fetchLeagues();
    }
  }, [user]);

  return (
    <main className="pageOuterWrapper">
      <Navbar />
      <div className="contentArea otherContentArea">
        <div className="wrapper">
          <div className="pageHeading">My Dashboard</div>
          <div className="yourLeagueHeader">
            <div className="headingItem">
              Your leagues{" "}
              {/* <span className="noDataTxt">(No leagues yet)</span> */}
            </div>
            <div className="actionItems">
              <button
                className="btnStyle btnFilled"
                onClick={handleCreateLeague}
              >
                <AddIcon /> CREATE
              </button>
              {/* <button className="btnStyle btnOutline">JOIN</button> */}
            </div>
          </div>
          <ul className="leagueList">
            {leagues.length === 0 && (
              <li className="noData">
                <span>NO LEAGUES YET</span>
              </li>
            )}
            {leagues.length > 0 &&
              leagues.map((league) => (
                <li
                  key={league.id}
                  onClick={() => navigate(`/${league.leagueUrl}`)}
                >
                  <div className="leagueImage">
                    <img
                      style={{ maxHeight: "100px" }}
                      src={league.bannerImage || defaultBannerImage}
                      alt={league.leagueName}
                    />
                  </div>
                  <div className="leagueInfo">
                    <div className="leagueName">{league.leagueName}</div>
                    <div className="leagueDetails"></div>
                  </div>
                </li>
              ))}
          </ul>
        </div>
      </div>
      {/* <div className="secondaryNav">
            <div className="wrapper">
                <ul>
                    <li className="active"><IconHome /></li>
                    <li><IconFace /></li>
                    <li><IconBook /></li>
                    <li><IconPrice /></li>
                    <li><IconHammer /> </li>
                    <li><IconMore /></li>
                </ul>
            </div>
        </div> */}
    </main>
  );
};

export default DashboardPage;
